import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableVoDOptimizationSettings from './tableVoDOptimizationSettings';

export default {
  title: 'Optimization Settings',
  attributeName: 'optimizationSettingsFormGroup',
  refreshUpdate: true,
  fields: [
    {
      attributeName: 'optimizationSettings',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableVoDOptimizationSettings,
    },
  ],
};
